import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=6732ae31&%3AtabData=tabData&%3AactiveTab=activeTab&"
import script from "./TabPanel.vue?vue&type=script&lang=js&"
export * from "./TabPanel.vue?vue&type=script&lang=js&"
import style0 from "./TabPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports